<template>
  <div class="PreSale">
    <div class="content">
      <p v-if="false"> {{ $t('per_sale.title', { days: countDown.days, hours: countDown.hours, mins: countDown.mins, secs: countDown.secs }) }}</p>
      <p v-if="true"> {{ $t('per_sale.title1') }}</p>
      <!-- <div class="buyBtn" @click="scrollToAnchor">{{ $t('per_sale.text') }}</div> -->
      <div class="buyBtn" @click="scrollToAnchor">{{ $t('per_sale.text1') }}</div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref, onMounted ,computed, watch} from "vue";
  import { useI18n } from "vue-i18n";
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'PreSale',
    setup() {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const dialogTableVisible = ref(false)
      const countDown = ref({
        days: 0,
        hours: 0,
        mins: 0,
        secs: 0
      })
      const getTime = async (endTime) => {
        const endTimeStamp = new Date(endTime).getTime();
        const interval = setInterval(() => {
          const now = new Date().getTime();
          const distance = endTimeStamp - now;
          if (distance < 0) {
            clearInterval(interval);
            return;
          }
          countDown.value.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          countDown.value.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          countDown.value.mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          countDown.value.secs = Math.floor((distance % (1000 * 60)) / 1000);
          if (countDown.value.days < 10) {
            countDown.value.days = '0' + countDown.value.days
          }
          if (countDown.value.hours < 10) {
            countDown.value.hours = '0' + countDown.value.hours
          }
          if (countDown.value.mins < 10) {
            countDown.value.mins = '0' + countDown.value.mins
          }
          if (countDown.value.secs < 10) {
            countDown.value.secs = '0' + countDown.value.secs
          }
        }, 1000);
      }
      const scrollToAnchor = () => {
        const element = document.getElementById("deeplink");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      onMounted(() => {
        getTime('2024-05-01 00:00:00')
      });
      watch(lan, (newValue) => {
        
      })
      return {
        lan,
        countDown,
        scrollToAnchor
      };
    }
  })
</script>
<style scoped lang="scss">
.PreSale {
  width: 100%;
  height: 48px;
  display: flex;
  // min-width: 1200px;
  font-style: normal;
  align-items: center;
  justify-content: center;
  background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 1) 114.86%);
  .content {
    display: flex;
    color: #FFF;
    align-items: center;
    .text {
      font-size: 18px;
      font-weight: 600;
      line-height: 27px;
      letter-spacing: 0em;
    }
    .buyBtn {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      margin-left: 24px;
      padding: 4px 20px;
      border-radius: 58px;
      letter-spacing: 0em;
      background: rgba(38, 45, 68, 1);
    }
  }
}


@media screen and (max-width: 900px) {
  .PreSale {
    // min-width: 600px;
    .content {
      font-size: 14px;
      .buyBtn {
        font-size: 12px;
      }
    }
  }
}
</style>
